import { isNull } from 'lodash-es';
import {
    FrequencyTypeCode,
    FrequencyTypeToFrequencyPair,
} from '../../../modules/application/direct-entry/schedules-d-and-h/models/frequency-type-codes';

export class FrequencyHelper {
    /**
     * Used to check if a frequency is between a given value
     * @param frequency A frequency number
     * @param range A frequency pair - e.g., FrequencyTypeToFrequencyPair[FrequencyTypeCode.TBand]; see frequency-type-codes.ts
     * @returns True or false, whether the frequency is between the given range
     */
    static isBetweenFrequencies(
        frequency: number | null | undefined,
        frequencyType: FrequencyTypeCode,
    ): boolean {
        const range = FrequencyTypeToFrequencyPair[frequencyType];

        if (frequency == null || isNaN(frequency)) {
            return false;
        }

        return frequency >= range.low && frequency <= range.high;
    }
    /**
     * Used to check if a frequency is between any of the given ranges
     * @param frequency A frequency number
     * @param ranges An array of frequency pairs - e.g., [FrequencyTypeToFrequencyPair[FrequencyTypeCode.TBand], FrequencyTypeToFrequencyPair[FrequencyTypeCode.Between806And870MHz]]
     * @returns True or false, whether the frequency is between any of the given ranges
     */
    static isBetweenAnyFrequencyRanges(
        frequency: number,
        frequencyTypes: FrequencyTypeCode[],
    ): boolean {
        if (frequency == null || isNaN(frequency)) {
            return false;
        }

        if (isNull(frequencyTypes) || frequencyTypes.length === 0) {
            throw new Error('No frequency types provided in method parameter.');
        }

        return frequencyTypes.some((frequencyType) =>
            FrequencyHelper.isBetweenFrequencies(frequency, frequencyType),
        );
    }
}
